// @flow

import { combineReducers, type Reducer } from 'redux';

import {
  createSequoiaResource,
  type ListState,
  type ResourceAction,
  type SequoiaResource,
  type SequoiaResourceType,
} from '@gandi/resource/redux';

export type TldPriceSummary = {
  /** Unicode (decoded) TLD name */
  name: string,
  /** ASCII (punycode-encoded) TLD name */
  alabel?: string,
  prices?: { ... },
  ...
};

export type State = {
  list: ListState<TldPriceSummary>,
};

export type TldPricesResourceType = SequoiaResourceType<{
  fetchResource: TldPriceSummary,
  fetchOneResource: empty,
}>;

export type TldPricesResource = SequoiaResource<TldPricesResourceType>;

export const tldPricesResource: TldPricesResource = createSequoiaResource(
  'tldpublic',
  'tlds',
  {
    fetchPath: 'tldpublic/tlds',
    statePath: 'tldpublic',
    getResourceId: resource => resource.name,
  },
);

export const reducer: Reducer<State, ResourceAction<>> = combineReducers({
  ...tldPricesResource.listReducer,
});
